import { createReducer, on } from '@ngrx/store';
import { AuthenticationState } from '../state';

const initialState: AuthenticationState = {
  user: null,
  token: null,
  isAuthenticated: false,
};

export const authenticationReducer = createReducer(initialState);
